import React from 'react';
import './ServiceGrid.css';
import { CONTACT_INFO } from '../constants';

function ServiceGrid() {
  const services = [
    {
      id: 1,
      title: 'Matrimonial',
      icon: '💑',
      description: 'Find your perfect match with matrimonial ads'
    },
    {
      id: 2,
      title: 'Public Notice',
      icon: '📢',
      description: 'Legal and official public notices'
    },
    {
      id: 3,
      title: 'Recruitment',
      icon: '👔',
      description: 'Job vacancies and career opportunities'
    },
    {
      id: 4,
      title: 'Property Sale',
      icon: '🏠',
      description: 'Sell residential and commercial properties'
    },
    {
      id: 5,
      title: 'Property Rent',
      icon: '🔑',
      description: 'Rent apartments, houses, and offices'
    },
    {
      id: 6,
      title: 'Name Change',
      icon: '📝',
      description: 'Legal name change announcements'
    },
    {
      id: 7,
      title: 'Lost & Found',
      icon: '🔍',
      description: 'Report lost items or documents'
    },
    {
      id: 8,
      title: 'Announcement',
      icon: '📣',
      description: 'Public announcements and notices'
    },
    {
      id: 9,
      title: 'Obituary',
      icon: '🕯️',
      description: 'Death notices and condolences'
    },
    {
      id: 10,
      title: 'Vehicle',
      icon: '🚗',
      description: 'Buy and sell vehicles'
    },
    {
      id: 11,
      title: 'Business',
      icon: '💼',
      description: 'Business ads and promotions'
    },
    {
      id: 12,
      title: 'Travel',
      icon: '✈️',
      description: 'Travel packages and tourism'
    },
    {
      id: 13,
      title: 'Remembrance',
      icon: '🌹',
      description: 'Memorial and remembrance notices'
    },
    {
      id: 14,
      title: 'Education',
      icon: '🎓',
      description: 'Educational institutions and courses'
    }
  ];

  const handleServiceClick = (service) => {
    const phoneNumber = CONTACT_INFO.PHONE.VALUE;
    const message = `Hi, I want to book a ${service.title} ad`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const newspapers = [
    { name: "Times of India", logo: "https://www.google.com/s2/favicons?domain=timesofindia.indiatimes.com&sz=128" },
    { name: "Hindustan Times", logo: "https://www.google.com/s2/favicons?domain=hindustantimes.com&sz=128" },
    { name: "The Hindu", logo: "https://www.google.com/s2/favicons?domain=thehindu.com&sz=128" },
    { name: "Dainik Jagran", logo: "https://www.google.com/s2/favicons?domain=jagran.com&sz=128" },
    { name: "Amar Ujala", logo: "https://www.google.com/s2/favicons?domain=amarujala.com&sz=128" },
    { name: "Malayala Manorama", logo: "https://www.google.com/s2/favicons?domain=manoramaonline.com&sz=128" },
    { name: "Rajasthan Patrika", logo: "https://www.google.com/s2/favicons?domain=patrika.com&sz=128" },
    { name: "Eenadu", logo: "https://www.google.com/s2/favicons?domain=eenadu.net&sz=128" },
    { name: "Deccan Chronicle", logo: "https://www.google.com/s2/favicons?domain=deccanchronicle.com&sz=128" },
    { name: "Economic Times", logo: "https://www.google.com/s2/favicons?domain=economictimes.indiatimes.com&sz=128" },
    { name: "Dainik Bhaskar", logo: "https://www.google.com/s2/favicons?domain=bhaskar.com&sz=128" },
    { name: "Anandabazar Patrika", logo: "https://www.google.com/s2/favicons?domain=anandabazar.com&sz=128" },
    { name: "Punjab Kesari", logo: "https://www.google.com/s2/favicons?domain=punjabkesari.in&sz=128" },
    { name: "Dinakaran", logo: "https://www.google.com/s2/favicons?domain=dinakaran.com&sz=128" },
    { name: "Sakshi", logo: "https://www.google.com/s2/favicons?domain=sakshi.com&sz=128" },
    { name: "Udayavani", logo: "https://www.google.com/s2/favicons?domain=udayavani.com&sz=128" },
    { name: "Prajavani", logo: "https://www.google.com/s2/favicons?domain=prajavani.net&sz=128" },
    { name: "Kannada Prabha", logo: "https://www.google.com/s2/favicons?domain=kannadaprabha.com&sz=128" },
    { name: "Andhra Jyothy", logo: "https://www.google.com/s2/favicons?domain=andhrajyothy.com&sz=128" },
    { name: "Namasthe Telangana", logo: "https://www.google.com/s2/favicons?domain=ntnews.com&sz=128" },
    { name: "Daily Thanthi", logo: "https://www.google.com/s2/favicons?domain=dailythanthi.com&sz=128" },
    { name: "Dinamalar", logo: "https://www.google.com/s2/favicons?domain=dinamalar.com&sz=128" },
    { name: "Mathrubhumi", logo: "https://www.google.com/s2/favicons?domain=mathrubhumi.com&sz=128" },
    { name: "Deshabhimani", logo: "https://www.google.com/s2/favicons?domain=deshabhimani.com&sz=128" }
  ];

  return (
    <section id="services" className="service-grid-section">
      <div className="container">
        <div className="newspaper-marquee-section">
          <p className="marquee-label">Book Ads in India's Top Newspapers</p>
          <div className="marquee-container">
            <div className="marquee-content">
              {newspapers.map((paper, index) => (
                <div key={index} className="newspaper-logo-wrapper">
                  <img 
                    src={paper.logo} 
                    alt={paper.name} 
                    className="newspaper-logo-img"
                    title={paper.name}
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = `https://placehold.co/150x50?text=${encodeURIComponent(paper.name)}`;
                    }}
                  />
                  <span className="newspaper-name-tooltip">{paper.name}</span>
                </div>
              ))}
              {/* Duplicate for seamless loop */}
              {newspapers.map((paper, index) => (
                <div key={`dup-${index}`} className="newspaper-logo-wrapper">
                  <img 
                    src={paper.logo} 
                    alt={paper.name} 
                    className="newspaper-logo-img"
                    title={paper.name}
                    onError={(e) => {
                      e.target.onerror = null; 
                      e.target.src = `https://placehold.co/150x50?text=${encodeURIComponent(paper.name)}`;
                    }}
                  />
                  <span className="newspaper-name-tooltip">{paper.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">Choose from our wide range of advertisement categories</p>
        
        <div className="service-grid">
          {services.map((service) => (
            <div 
              key={service.id}
              className="service-card"
              onClick={() => handleServiceClick(service)}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServiceGrid;
